
import { z } from "zod";

export const formSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters"),
  email: z.string().email("Please enter a valid email address"),
  company: z.string().min(2, "Company name must be at least 2 characters"),
  title: z.string().min(2, "Job title must be at least 2 characters"),
  linkedin: z.string().optional(),
  phone: z.string().min(5, "Phone number must be at least 5 characters"),
  honey: z.string().optional(),
  recaptcha: z.string().min(1, "Please complete the reCAPTCHA verification"),
});

export type FormValues = z.infer<typeof formSchema>;
